import type { IconProps } from './types';

export const ArrowUp = ({ size, ...props }: IconProps) => (
  <svg fill="none" width={size} height={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.00004 12.6666V3.33331M8.00004 3.33331L3.33337 7.99998M8.00004 3.33331L12.6667 7.99998"
      stroke="currentColor"
      stroke-width="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
